"use strict";

exports.__esModule = true;
exports.PerformanceParameterValueFields = PerformanceParameterValueFields;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Translator = require("../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Fields for PerformanceParameterValueElement.
 */
function PerformanceParameterValueFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("PerformanceParameterValueFields.dataItemIndex.label", "Parameter"),
      helperText: translate("PerformanceParameterValueFields.dataItemIndex.helperText", "Note: This widget will appear blank for devices without corresponding performance parameters.")
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _core.Classes.HTML_SELECT
    }, /*#__PURE__*/_react["default"].createElement("select", {
      value: element.props.dataItemIndex,
      onChange: function onChange(e) {
        return elementEditor.setProp(path, "dataItemIndex", e.target.value);
      }
    }, /*#__PURE__*/_react["default"].createElement("option", {
      value: 0
    }, translate("PerformanceParameterValueFields.dataItemIndex.parameter1", "Parameter 1")), /*#__PURE__*/_react["default"].createElement("option", {
      value: 1
    }, translate("PerformanceParameterValueFields.dataItemIndex.parameter2", "Parameter 2")), /*#__PURE__*/_react["default"].createElement("option", {
      value: 2
    }, translate("PerformanceParameterValueFields.dataItemIndex.parameter3", "Parameter 3")), /*#__PURE__*/_react["default"].createElement("option", {
      value: 3
    }, translate("PerformanceParameterValueFields.dataItemIndex.parameter4", "Parameter 4")), /*#__PURE__*/_react["default"].createElement("option", {
      value: 4
    }, translate("PerformanceParameterValueFields.dataItemIndex.parameter5", "Parameter 5")), /*#__PURE__*/_react["default"].createElement("option", {
      value: 5
    }, translate("PerformanceParameterValueFields.dataItemIndex.parameter6", "Parameter 6"))))), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("PerformanceParameterValueFields.dataItemDecimalPlaces.label", "Decimal places")
    }, /*#__PURE__*/_react["default"].createElement(_core.NumericInput, {
      clampValueOnBlur: true,
      min: 1,
      max: 10,
      stepSize: 1,
      minorStepSize: null,
      value: element.props.decimalPlacesString || element.props.decimalPlaces,
      onValueChange: function onValueChange(numberValue, stringValue) {
        var value = numberValue;
        if (stringValue === "") {
          value = undefined;
        } else if (value > 10) {
          value = 10;
        } else if (value < 1) {
          value = 1;
        }
        if (value) {
          value = Math.trunc(value);
        }
        elementEditor.setProps(path, {
          decimalPlaces: value,
          decimalPlacesString: stringValue
        });
      }
    })), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
      checked: element.props.hideLabel || false,
      label: translate("PerformanceParameterValueFields.hideLabel.label", "Hide Label"),
      onChange: function onChange(e) {
        return elementEditor.setProp(path, "hideLabel", e.target.checked);
      }
    }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
      checked: element.props.hideMtcAgentUnits || false,
      label: translate("PerformanceParameterValueFields.hideMtcAgentUnits.label", "Hide MTC Agent Units"),
      onChange: function onChange(e) {
        return elementEditor.setProp(path, "hideMtcAgentUnits", e.target.checked);
      }
    }));
  });
}